import { Controller } from '@hotwired/stimulus'
import EasyMDE from 'easymde'

export default class extends Controller {
  static values = { editor: String }

  connect() {
    new EasyMDE({
      element: this.element,
      status: false,
      spellChecker: false,
      previewRender: async (plainText, previewElement) => {
        try {
          const response = await fetch('/blogging/markdown/render', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({ markdown: plainText })
          })

          if (response.ok) {
            const data = await response.json()

            const updatedHtml = this.addTargetBlankToPreview(data)

            previewElement.innerHTML = updatedHtml
          } else {
            console.error('Error rendering Markdown:', response.statusText)
            previewElement.innerHTML = `<p>Error rendering preview</p>`
          }
        } catch (error) {
          console.error('Error:', error)
          previewElement.innerHTML = `<p>Error fetching html from markdown</p>`
        }
      },
      toolbar: this.customToolbar(),
      minHeight: this.customHeight()

    })
  }

  addTargetBlankToPreview(data) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(data.html, 'text/html')

    doc.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank')
    })

    return doc.body.innerHTML
  }

  customHeight() {
    switch (this.editorValue) {
      case 'blog_post_header':
        return '100px'
      case 'blog_category_header':
        return '100px'
      default:
       '300px'
    }
  }

  customToolbar() {
    switch (this.editorValue) {
      case 'blog_post_header':
        return this.blogPostHeaderToolbar()
      case 'blog_post_content':
        return this.blogPostContentToolbar()
      case 'blog_category_header':
        return this.blogCategoryHeaderToolbar()
      case 'blog_category_content':
        return this.blogCategoryContentToolbar()
      default:
       console.log('Default toolbar')
    }
  }

  blogCategoryHeaderToolbar() {
    return ['link', '|', 'preview']
  }

  blogCategoryContentToolbar() {
    return [
      {
        text: "H2",
        action: EasyMDE.toggleHeading2
      },
      {
        text: "H3",
        action: EasyMDE.toggleHeading3,
      },
      {
        text: "H4",
        action: EasyMDE.toggleHeading4,
      },
      '|',
      'bold',
      'italic',
      '|',
      'unordered-list',
      'ordered-list',
      '|',
      'link',
      {
        name: "related-article",
        action: (editor) => {
          const cm = editor.codemirror
          const htmlSnippet = `
:::related-link
#### Title goes here
Content
:::
`
          cm.replaceSelection(htmlSnippet)
        },
        className: "fa fa-bookmark",
        title: "Insert a component for a related article"
      },
      '|',
      'preview'
    ]
  }

  blogPostHeaderToolbar() {
    return [
      'bold',
      'italic',
      '|',
      'unordered-list',
      'ordered-list',
      '|',
      'link',
      '|',
      {
          name: "related-article",
          action: (editor) => {
            const cm = editor.codemirror
            const htmlSnippet = `
:::related-link
#### Title goes here
Content
:::
`
            cm.replaceSelection(htmlSnippet)
          },
          className: "fa fa-bookmark",
          title: "Insert a component for a related article"
      },
      '|',
      'preview'
    ]
  }

  blogPostContentToolbar() {
    return [
        {
          text: "H2",
          action: EasyMDE.toggleHeading2
        },
        {
          text: "H3",
          action: EasyMDE.toggleHeading3,
        },
        {
          text: "H4",
          action: EasyMDE.toggleHeading4,
        },
        '|',
        'bold',
        'italic',
        '|',
        {
          name: "quotation",
          className: "fa fa-quote-left",
          action: (editor) => {
            const cm = editor.codemirror
            const htmlSnippet = `"your quote"`
            cm.replaceSelection(htmlSnippet)
          },
          title: "Insert a quotation"
        },
        {
          name: "quote",
          title: "Insert a testimony",
          action: EasyMDE.toggleBlockquote,
          text: ">|",
        },
        'unordered-list',
        'ordered-list',
        '|',
        'link',
        {
          name: "image",
          className: "fa fa-image",
          action: (editor) => {
            const cm = editor.codemirror
            const htmlSnippet = `
:::figure
Click on an added asset and paste image link here
:::figcaption
image caption here
:::
:::
`
            cm.replaceSelection(htmlSnippet)
          },
          title: "Insert an image"
        },
        '|',
        {
            name: "related-article",
            action: (editor) => {
              const cm = editor.codemirror
              const htmlSnippet = `
:::related-link
#### Title goes here
Content
:::
`
              cm.replaceSelection(htmlSnippet)
            },
            className: "fa fa-bookmark",
            title: "Insert a component for a related article"
        },
        {
          name: "CTA",
          action: (editor) => {
            const cm = editor.codemirror
            const htmlSnippet = `
:::call-to-action
:::picture
Click on an added asset and paste image link here
:::
#### Title goes here
Content goes here

[link to free nouslib signup](https://www.nouslib.com)
:::
`
            cm.replaceSelection(htmlSnippet)
          },
          className: "fa fa-star",
          title: "Insert a custom call to action"
        },
        {
          name: "copyright",
          action: (editor) => {
            const cm = editor.codemirror
            const htmlSnippet = `
:::post-sources
copyright text
:::
`
            cm.replaceSelection(htmlSnippet)
          },
          className: "fa fa-copyright",
          title: "Insert a copyright"
        },
        '|',
        'preview'
    ]
  }
}
